module.exports = __webpack_public_path__ + "static/privacy-a42f4670c029dd379988ffeb9c235dfb.pdf";